// extracted by mini-css-extract-plugin
export default {"visionMissionDiv":"VisionMission_visionMissionDiv__jdnmO"};